"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _HiFormControl = _interopRequireDefault(require("./HiFormControl"));
var _HiUpload = _interopRequireDefault(require("./HiUpload"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var HiUploadField = /*#__PURE__*/function (_React$PureComponent) {
  function HiUploadField() {
    (0, _classCallCheck2.default)(this, HiUploadField);
    return _callSuper(this, HiUploadField, arguments);
  }
  (0, _inherits2.default)(HiUploadField, _React$PureComponent);
  return (0, _createClass2.default)(HiUploadField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        label = _this$props.label,
        helperIcon = _this$props.helperIcon,
        helperText = _this$props.helperText,
        values = _this$props.values,
        fullWidth = _this$props.fullWidth,
        required = _this$props.required,
        HiInputLabelProps = _this$props.HiInputLabelProps,
        others = (0, _objectWithoutProperties2.default)(_this$props, ["className", "label", "helperIcon", "helperText", "values", "fullWidth", "required", "HiInputLabelProps"]);
      var empty = true;
      var error = false;
      var errorText = '';
      for (var i = 0, len = values.length; i < len; i += 1) {
        var value = values[i];
        if (value !== undefined) {
          empty = value.value !== null && !value.error ? false : empty;
          error = value.error || error;
          errorText += "".concat(value.errorMessage);
        }
      }
      return /*#__PURE__*/_react.default.createElement(_HiFormControl.default, {
        label: label,
        className: className,
        errorText: errorText,
        error: error,
        helperIcon: helperIcon,
        helperText: helperText,
        fullWidth: fullWidth,
        required: required,
        InputLabelProps: HiInputLabelProps
      }, /*#__PURE__*/_react.default.createElement(_HiUpload.default, (0, _extends2.default)({
        values: values
      }, others)));
    }
  }]);
}(_react.default.PureComponent);
HiUploadField.defaultProps = {
  helperText: '',
  helperIcon: false,
  seeFile: true,
  fullWidth: false,
  required: true
};
var _default = exports.default = HiUploadField;